export const emailValidateRule = /^[\w+\-.]+@[a-z\d\-.]+\.[a-z]+$/i;
export const passwordValidateRule =
  /^[a-z\d!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]{8,}$/i;
